import React from 'react';
import Header from '../components/navigation';
import Footer from '../components/Footer';


const ErrorPage = () => {
  const handleGoBack = () => {
    window.history.back();
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <>
    <Header/>
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8">

        {/* Error Details Card */}
        <div className="bg-white p-6 rounded-lg shadow-md space-y-6">
          <div className="text-center">
            <h1 className="text-6xl font-bold text-gray-900 mb-2">404</h1>
            <p className="text-xl text-gray-600 mb-4">Page Not Found</p>
            <p className="text-gray-500">
              The page you are looking for might have been removed, had its name changed,
              or is temporarily unavailable.
            </p>
          </div>

        </div>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default ErrorPage;